import React from 'react';
import { FormattedMessage } from '../../util/reactIntl';
import { formatMoney } from '../../util/currency';
import { LINE_ITEM_PRINTEMPS_ROBOUP_DISCOUNT } from '../../util/types';

import css from './OrderBreakdown.module.css';

const LineItemPrintempsRoboupDiscountMaybe = props => {
  const { lineItems, intl } = props;

  const discountLine = lineItems.find(
    item => item.code === LINE_ITEM_PRINTEMPS_ROBOUP_DISCOUNT && !item.reversal
  );

  return discountLine ? (
    <div className={css.lineItem}>
      <span className={css.itemLabel}>
        <FormattedMessage id="OrderBreakdown.printempsRoboupDiscount" />
      </span>
      <span className={css.itemValue}>{formatMoney(intl, discountLine.lineTotal)}</span>
    </div>
  ) : null;
};

export default LineItemPrintempsRoboupDiscountMaybe;
